"use strict";

//UNDERSCORE
var underscore = angular.module('underscore', []);
underscore.factory('_', function () {
  return window._;
});

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

function escapeRegExp(string) {
  return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function translit(value) {
  var space = '-';
  var text = value.toLowerCase();

  var transl = {
    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'e', 'ж': 'zh',
    'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
    'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h',
    'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'sh', 'ъ': space, 'ы': 'y', 'ь': space, 'э': 'e', 'ю': 'yu', 'я': 'ya',
    ' ': space, '_': space, '`': space, '~': space, '!': space, '@': space,
    '#': space, '$': space, '%': space, '^': space, '&': space, '*': space,
    '(': space, ')': space, '-': space, '\=': space, '+': space, '[': space,
    ']': space, '\\': space, '|': space, '/': space, '.': space, ',': space,
    '{': space, '}': space, '\'': space, '"': space, ';': space, ':': space,
    '?': space, '<': space, '>': space, '№': space
  };

  var result = '';
  var current_sim = '';

  for (var i = 0; i < text.length; i++) {
    if (transl[text[i]] != undefined) {
      if (current_sim != transl[text[i]] || current_sim != space) {
        result += transl[text[i]];
        current_sim = transl[text[i]];
      }
    }
    else {
      result += text[i];
      current_sim = text[i];
    }
  }

  return result;
}

var hostname = window.location.host + '/discovery';

var protocol = window.location.protocol.replace(':', '');

$(document).ready(function(){
    $.event.addProp('dataTransfer');
});

/**
 * Config for LH SDK
 */
lh.common.config.set({
  endpoint: {
    hostname: hostname,
    port: 80,
    protocol: protocol,
    timeout: 60 * 1000 * 5
  },
  loggingLevel: 'error'
});

/**
 * Main Angular Module
 * @type {module|*}
 */
var lmApp = angular
  .module('lmApp', [
    'vcRecaptcha',
    'ngKookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'ngAnimate',
    'underscore',
    'angular-cron-jobs',
    'ui.codemirror',
    'chart.js',
    'ngCsv'
  ]);

lmApp
  .config(['$kookiesProvider',
    function ($kookiesProvider) {
      $kookiesProvider.config.json = true;
    }
  ]);
